var childContainer = $('.topic--commented');
var counter = 0;

$('.tabs--medium .tabs__tab').each(function(event) {
  $(event.currentTarget).prop('number', counter);
  counter++;
});

$('.tabs--medium .tabs__tab').on('click', function(event) {
  var $self = $(event.currentTarget);
  $('.tabs--medium .tabs__tab').removeClass('tab--active');
  $self.addClass('tab--active');
  $('.topic--commented').removeClass('topic--active');
  $(childContainer[$self.prop('number')]).addClass('topic--active');
});

$('.personalBlock__switch').on('click', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var $container = $self.parent('.personalBlock__column');
  var $target = $container.find('.personalBlock__container');
  var $button = $container.find('.personalBlock__switch i');

  if ( $container.hasClass('open') ) {
    $target.slideUp();
    $container.removeClass('open');
    $button.css({'transform': 'rotate(180deg)'});
  } else {
    $target.slideDown();
    $container.addClass('open');
    $button.css({'transform': 'rotate(0deg)'});
  }
});

$('.personalBlock__showmore').on('click', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var $container = $self.parent('.personalBlock__container');
  var $target = $container.find('.personalBlock__expand');

  if ( $container.hasClass('expanded') ) {
    $target.slideUp();
    $container.removeClass('expanded');
    $self.html('Toon meer');
  } else {
    $target.slideDown();
    $container.addClass('expanded');
    $self.html('Toon minder');
  }
});

$('.more--action').on('click', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var $container = $('.personalBlock__column.current--large');
  var $target = $container.find('.personalBlock__container');

  if ($container.hasClass('expanded')) {
    $container.removeClass('expanded');
    $target.find('.personalBlock__expand').slideUp();
    $self.html('Toon meer');
  } else {
    $container.addClass('expanded');
    $target.find('.personalBlock__expand').slideDown();
    $self.html('Toon minder');
  }
});

$('.personalBlock__edit').on('click', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var $container = $self.parent('.personalBlock__column');
  var $target = $container.find('.personalBlock__body');
  var $button = $container.find('.personalBlock__item--delete');

  if ( $container.hasClass('edit') ) {
    $target.css({'left': '0'});
    $container.removeClass('edit');
    $button.fadeOut('fast');
  } else {
    $target.css({'left': '50px'});
    $container.addClass('edit');
    $button.fadeIn('fast');
  }
});

$('.A_POSTS .personalBlock__item--delete').on('click', function(event) {
    'use strict';
    var $self = $(event.currentTarget);
    var $container = $self.parent('.personalBlock__item');
    var $block = $container.parent('.personalBlock__container');
    var $expand = $block.find('.personalBlock__expand');
    var $showmore = $block.find('.personalBlock__showmore');
    var postId = $container.attr('data-post');

    $.ajax({
        type: 'get',
        url: '/pb/bookmark/remove/'+postId,
        success: function() {
            $container.slideUp();
            // Check if block contains more than 3 posts
            if (
                $expand.length &&
                $expand.find('.personalBlock__item').length > 0 ) {
                var $elem = $expand.find('.personalBlock__item').first();
                var $last = $block.find('.personalBlock__expand');
                $elem.insertBefore($last);
                if ( $expand.find('.personalBlock__item').length < 1 ) {
                    $showmore.slideUp();
                    $expand.remove();
                }
            }
        }
    });
});

$('.A_COMMENTED .personalBlock__item--delete' ).on('click', function(event) {
    'use strict';
    var $self = $(event.currentTarget);
    var $container = $self.parent('.personalBlock__item');
    var $block = $container.parent('.personalBlock__container');
    var $expand = $block.find('.personalBlock__expand');
    var $showMore = $block.find('.personalBlock__showmore');
    var topicId = $container.attr('data-id');
    var userId =  $('.js-myaccount').attr( 'js-data-userid' );

    $.ajax({
        type: 'GET',
        url: '/pb/remove_own_topic',
        data: {topicId: topicId, userId: userId},
        success: function() {
            $container.slideUp();
            // Check if block contains more than 3 posts
            if (
                $expand.length &&
                $expand.find('.personalBlock__item').length > 0 ) {
                var $elem = $expand.find('.personalBlock__item').first();
                var $last = $block.find('.personalBlock__expand');
                $elem.insertBefore($last);
                if ( $expand.find('.personalBlock__item').length < 1 ) {
                    $showMore.slideUp();
                    $expand.remove();
                }
            }
        }
    });
});

$('.A_STARTED .personalBlock__item--delete' ).on('click', function(event) {
    'use strict';
    var $self = $(event.currentTarget);
    var $container = $self.parent('.personalBlock__item');
    var $block = $container.parent('.personalBlock__container');
    var $expand = $block.find('.personalBlock__expand');
    var $showMore = $block.find('.personalBlock__showmore');
    var topicId = $container.attr('data-id');
    var userId =  $('.js-myaccount').attr( 'js-data-userid' );

    $.ajax({
        type: 'GET',
        url: '/pb/remove_own_topic',
        data: {topicId: topicId, userId: userId},
        success: function() {
            $container.slideUp();
            // Check if block contains more than 3 posts
            if (
                $expand.length &&
                $expand.find('.personalBlock__item').length > 0 ) {
                var $elem = $expand.find('.personalBlock__item').first();
                var $last = $block.find('.personalBlock__expand');
                $elem.insertBefore($last);
                if ( $expand.find('.personalBlock__item').length < 1 ) {
                    $showMore.slideUp();
                    $expand.remove();
                }
            }
        }
    });
});

$('.A_BOOKMARK .personalBlock__item--delete').on('click', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var $container = $self.parent('.personalBlock__item');
  var $block = $container.parent('.personalBlock__container');
  var $expand = $block.find('.personalBlock__expand');
  var $showmore = $block.find('.personalBlock__showmore');
  var topicId = $container.attr('data-id');
  var postId = $container.attr('data-post');
  var userId =  $('.js-myaccount').attr( 'js-data-userid' );

  $.ajax({
    type: 'GET',
    url: '/pb/remove',
    data: {topicId: topicId, postId: postId, userId: userId},
    success: function() {
      $container.slideUp();
      // Check if block contains more than 3 posts
      if (
          $expand.length &&
          $expand.find('.personalBlock__item').length > 0 ) {
        var $elem = $expand.find('.personalBlock__item').first();
        var $last = $block.find('.personalBlock__expand');
        $elem.insertBefore($last);
        if ( $expand.find('.personalBlock__item').length < 1 ) {
          $showmore.slideUp();
          $expand.remove();
        }
      }
    }
  });
});

$('.personalBlock__header--mobile').on('click', 'span', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var tab = $self.attr('data-tab');
  var $current = $('.personalBlock__content.current');

  if ( !$self.hasClass('selected') ) {
    $('.selected').removeClass('selected');
    $current.removeClass('current');
    $self.addClass('selected');

    $current.fadeOut(500, function() {
      $(tab).fadeIn(400).addClass('current');
    });
  }
});

$('.edit--action').on('click', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var $container = $('.current--large');
  var $target = $container.find('.personalBlock__body');
  var $button = $container.find('.personalBlock__item--delete');
  if ( $container.hasClass('edit') ) {
    $target.css({'left': '0'});
    $container.removeClass('edit');
    $button.fadeOut('fast');
  } else {
    $target.css({'left': '50px'});
    $container.addClass('edit');
    $button.fadeIn('fast');
  }
});

$('.personalBlock__header--large').on('click', 'span', function(event) {
  'use strict';
  var $self = $(event.currentTarget);
  var tab = $self.attr('data-tab');
  var $current = $('.personalBlock__column.current--large');

  if ( !$self.hasClass('selected') ) {
    $('.selected').removeClass('selected');
    $current.removeClass('current--large');
    $self.addClass('selected');
    $(tab).addClass('current--large');
    $current.fadeOut(300, function() {
      $(tab).fadeIn(250);
    });
  }
});